class MatchProfileController {
  constructor(
    MatchesFactory,
    $state,
    $scope,
    $rootScope,
    $window,
    $filter,
    Permissions
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;
    $state.current.data.hideSidebar = true;
    vm.$onInit = () => {
      vm.state = $state;
      vm.match = {};
      vm.matchSections = [
        {
          state: "match-profile.targets",
          name: "TARGETS",
          permission: Permissions.EDIT_MATCH_TARGETS,
        },
        {
          state: "match-profile.leagues",
          name: "LEAGUES",
          permission: Permissions.EDIT_MATCH_LEAGUES,
        },
        {
          state: "match-profile.prints",
          name: "PRINTS",
          // permission: Permissions.MATCH_PRINTS
        },
        {
          state: "match-profile.eliminations",
          name: "ELIMINATION_ROUNDS",
          permission: Permissions.MATCH_ELIMINATION_ROUNDS,
        },
        {
          state: "match-profile.finalize",
          name: "FINALIZE_MATCH",
          permission: Permissions.UPDATE_MATCH,
        },
        { state: "match-profile.registrations", name: "REGISTRATIONS" },
        {
          state: "match-profile.addShots",
          name: "ADD_SHOTS",
          permission: Permissions.ADD_SCORE_TO_MATCH,
        },
        {
          state: "match-profile.addShotsIndividual",
          name: "ADD_SHOTS_INDIVIDUAL",
          permission: Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS,
        },
        {
          state: "match-profile.addShotsTeam",
          name: "ADD_SHOTS_TEAM",
          permission: Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS,
        },
        {
          state: "match-profile.addShotsMixedTeam",
          name: "ADD_SHOTS_MIXED_TEAM",
          permission: Permissions.ADD_SCORE_TO_MATCH_ELIMINATION_ROUNDS,
        },
        {
          state: "match-profile.addShotsVisual",
          name: "ADD_SHOTS_VISUAL",
          permission: Permissions.ADD_SCORE_TO_MATCH,
        },
      ];
    };

    vm.goToVisualEliminations = () => {
      window.location.href = `/match-profile/shotsIndividualVisual/${vm.rootScope.currentMatchId}`;
    };

    vm.formatDate = (date) => {
      return new Date(date);
    };

    vm.isRegistrationOpen = () => {
      let now = new Date();
      let start = new Date(vm.match.registration_start);
      let end = new Date(vm.match.registration_end);
      let isOpen = now > start && now < end;
      if (isOpen) {
        vm.registrationText = $translate("REGISTRATION_OPEN");
      } else {
        vm.registrationText = $translate("REGISTRATION_CLOSED");
      }
      return isOpen;
    };

    vm.getMatchImage = function () {
      return "assets/images/target.png";
    };

    vm.exitMatch = () => {
      vm.rootScope.clearMatchData();
      $state.go("matches-list");
    };

    if (vm.rootScope.currentMatchId) {
      MatchesFactory.getOne(vm.rootScope.currentMatchId).then((response) => {
        vm.match = response.data;
        $rootScope.updateMatchData(response.data);
      });
    }
  }
}

export default MatchProfileController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchProfile.controller.js